import { createStore } from "vuex";
import gallery from "@@/store/gallery";
import common from "@@/store/common";
import image from "@@/store/image";
import user from "@@/store/user";
import ai from "@@/store/ai";


export default defineNuxtPlugin((nuxtApp) => {
  const store = createStore({
    modules: {
      gallery,
      common,
      image,
      user,
      ai
    },
  });
  nuxtApp.vueApp.use(store);
  nuxtApp.provide("store", store);
});
